// extracted by mini-css-extract-plugin
export var container = "_ib-1";
export var cornerButtonContainer = "_ib-6";
export var disabled = "_ib-2";
export var dragActive = "_ib-3";
export var fileContainer = "_ib-5";
export var hiddenInput = "_ib-4";
export var widthContainer = "_ib-0";